import { fetchPost, fetchGet, fetchPatch } from "@/lib/services";



export async function createNotice(data:any) {
  return await fetchPost("/notices/", data);
}
 
export async function updateNotice(noticeId:number,data:any) {
    return await fetchPatch(`/notices/?Id=${noticeId}`,data);
}

export async function getNotices() {
    return await fetchGet(`/notices/`);
}
